import React, { useEffect, useState } from "react";
import axios from "axios";
import Topbar from '../components/topbar'; 
import Sidebar from '../components/sidebar'; 
import Footer from '../components/footer'; 
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

const API_ROOMS = `${BASE_URL}admin/getdata/rooms.php`;
const API_INVENTORY = `${BASE_URL}admin/getdata/room_inventory.php`;

const RoomInventory = () => {
  const [rooms, setRooms] = useState([]);
  const [inventory, setInventory] = useState([]);
  const [roomId, setRoomId] = useState("");
  const [noOfRooms, setNoOfRooms] = useState("");
  const [editing, setEditing] = useState(null);

  const loadData = async () => {
    const r = await axios.get(`${API_ROOMS}?action=list`);
    const i = await axios.get(`${API_INVENTORY}?action=list`);
    setRooms(r.data);
    setInventory(i.data);
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!roomId || !noOfRooms) return alert("All fields required 🔔");

    const payload = { room_id: roomId, no_of_rooms: noOfRooms };

    if (editing) {
      await axios.post(`${API_INVENTORY}?action=update`, {
        ...payload,
        id: editing.id,
      });
    } else {
      await axios.post(`${API_INVENTORY}?action=create`, payload);
    }

    setRoomId("");
    setNoOfRooms("");
    setEditing(null);
    loadData();
  };

  const handleEdit = (item) => {
    setEditing(item);
    setRoomId(item.room_id);
    setNoOfRooms(item.no_of_rooms);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Delete this record?")) {
      await axios.post(`${API_INVENTORY}?action=delete`, { id });
      loadData();
    }
  };

  return (
    <div class="header-light sidebar-dark sidebar-expand">
        <Topbar />
        <div class="content-wrapper">
        <Sidebar />  
         <main class="main-wrapper clearfix">
                  <div class="widget-list">
    <div className="container mt-4">
      <h3>Add No of Rooms</h3>

      <div className="card mt-3">
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <label>Room Name</label>
            <select
              className="form-control mb-2"
              value={roomId}
              onChange={(e) => setRoomId(e.target.value)}
            >
              <option value="">Select Room Name</option>
              {rooms.map((r) => (
                <option key={r.id} value={r.room_id}>
                  {r.category_name}
                </option>
              ))}
            </select>

            <label>No of Rooms</label>
            <input
              type="number"
              className="form-control mb-3"
              value={noOfRooms}
              onChange={(e) => setNoOfRooms(e.target.value)}
            />

            <button className="btn btn-primary" type="submit">
              {editing ? "Update" : "Submit"}
            </button>
          </form>
        </div>
      </div>

      <h4 className="mt-4">View No of Rooms</h4>
      <div className="card">
        <div className="card-body p-0">
          <table className="table table-bordered mb-0">
            <thead>
              <tr>
                <th>#</th>
                <th>Room Name</th>
                <th>No of Rooms</th>
                <th style={{ width: "120px" }}>Action</th>
              </tr>
            </thead>
            <tbody>
              {inventory.map((item, i) => (
                <tr key={item.id}>
                  <td>{i + 1}</td>
                  <td>{item.room_name}</td>
                  <td>{item.no_of_rooms}</td>
                  <td>
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      onClick={() => handleEdit(item)}
                    >
                      ✏️
                    </button> &nbsp;
                    <button
                      className="btn btn-sm btn-danger"
                      onClick={() => handleDelete(item.id)}
                    >
                      🗑
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
</div>
</main>
</div>
</div>

  );
};

export default RoomInventory;
